import React, { createContext, useContext, useEffect, useState } from "react";
import { deleteAllCookies, getCookie, reloadWindow, reloadWindowToPath, setCookie } from "../Helpers/Utils";
import { useDispatch } from "react-redux";
import Handler from "../Helpers/Handler";
const AuthContext = createContext();

function AuthenticateProvider({ children }) {
  const [userDetails, setUserDetails] = useState({})
  const dispatch = useDispatch()
  const token = getCookie("token")
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const logIn = (token, person) => {
    if (token) {
      localStorage.removeItem('filter')
      setCookie("token", token);
      setCookie("person", person);
      setIsAuthenticated(true);
    }
  };
  const logOut = async () => {
    localStorage.removeItem('homeSearch')
    deleteAllCookies()
    localStorage.removeItem('filter')
    setIsAuthenticated(false);
    setTimeout(() => {
      reloadWindowToPath('/login');
    }, 1500);
  }
  const getDetails = async () => {
    const person = getCookie('person')
    if (person && isAuthenticated) {
      const value = await Handler({ method: "get", url: `/${person === 'admin' ? "admin" : "user"}/view` });
      if (value?.success) {
        setUserDetails(value?.data)
      }
    }
  }
  useEffect(() => {
    if (token) {
      getDetails()
      setIsAuthenticated(true);
    }
  }, [token]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     reloadWindowToPath('/')
  //   }
  // }, [isAuthenticated])
  return (
    <AuthContext.Provider value={{ logIn, logOut, isAuthenticated, userDetails, setIsAuthenticated, getDetails }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthenticateProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};